import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
    :root {
        --gold: rgb(146,133,81);
        --grey: rgb(102,102,102);
        --light-purple: rgb(191,188,220);
    }

    html {
        background-image: linear-gradient(to bottom, #666666, #818181, #9c9c9c, #b9b9b9, #d6d6d6, #d6d6d6, #d6d6d6, #d6d6d6, #b9b9b9, #9c9c9c, #818181, #666666);
    }

    body {
        max-width: 1200px;
        min-height: 100vh;
        background-color: var(--light-purple);
        margin: auto;
        position: relative;
    }

    img {
        max-width: 100%;
    }
`;

export default GlobalStyles;
